/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var config = require('../../config/Config');
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(formData, id, fileName, supportingFileBase64) {
  var deferred = $.Deferred();
  $.soap({
    url: config.getAnonymousDoBSUrl(),
    body: {
      UpdateComplaintFormAttachment: {
        $xmlns: 'http://dobs.pa.gov/complaint/db/1.0',
        tuple: {
          new: {
            ComplaintFormAttachment: {
              ComplaintFormId: id,
              filename: fileName,
              Attachment: supportingFileBase64
            }
          }
        }
      }
    },
    blueprint: {
      id: '$..tuple.new.ComplaintFormAttachment.id'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};

